class NoStockModal extends ModalDialog {
    constructor() {
        super();
    }

    connectedCallback() {
        this.modalContent = this.querySelector('.no-stock-modal__content');
    }

    hide(preventFocus = false) {
        if (preventFocus) this.openedBy = null;
        this.querySelector(".no-stock-modal__content").innerHTML = '';
        this.removeAttribute("open");
        super.hide();
    }

    show() {
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
    }

    setInnerHTML(html) {
        const errorMessage = document.createElement("div");
        errorMessage.innerHTML = `
        <div class="product-form__error-message-wrapper" role="alert">
            <span class="product-form__error-message">
                <span>
                    <svg><use xlink:href="#shopify-svg__error"></use></svg>
                </span>
                ${html}
            </span>
        </div>`;

        if (this.querySelector(".no-stock-modal__content")) {
            this.querySelector(".no-stock-modal__content").appendChild(errorMessage);
        }
    }
}

customElements.define('no-stock-modal', NoStockModal);

document.addEventListener("DOMContentLoaded", () => {
    const closeButton = document.querySelector('no-stock-modal #noStockClose');
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            document.querySelector("no-stock-modal").hide();
        });
    }

    const backface = document.querySelector('no-stock-modal .modal-backface');
    if (backface) {
        backface.addEventListener('click', () => {
            document.querySelector("no-stock-modal").hide();
        });
    }
})